import { SubscribeCustomerToNewsletter } from '../newsletter-subscribe';

const DyNewsletterPullUpExperience = () => {
  const els = {
    subscribeForm: '#dy-newsletter-pullup__form-section',
    subscribeFormParent: '#dy-newsletter-pullup__content',
    subscribeFormHeading: '#dy-newsletter-pullup__heading',
    subscribeFormSubHeading: '#dy-newsletter-pullup__subheading',
    newsletterFormSelector: '#dy-newsletter-pullup__form',
    emailInputSelector: 'input[name="contact[email]"]',
    genderDropdownSelector: 'select#dy-newsletter-pullup__gender',
  };

  $(document).on('submit', els.newsletterFormSelector, (e) => {
    e.preventDefault();
    const DyNewsletterPullup = {
      $container: $(els.subscribeForm),
      $form: $(els.subscribeForm).find('form'),
      $emailInput: $(els.subscribeForm).find(els.emailInputSelector),
      $genderDropdown: $(els.subscribeForm).find(els.genderDropdownSelector),
      $formHeading: $(els.subscribeFormHeading),
      $formSubHeading: $(els.subscribeFormSubHeading),
      formID: $(els.subscribeForm).find('form').attr('id'),
      parentClass: els.subscribeFormParent,
      actionURL: $(els.subscribeForm).find('form').data('action-url'),
      successMsg:
        "<div class='dy-newsletter-pullup__success subscribe-form__content-copy-success'><h3 class='note note--success'>Thanks! You have been successfully subscribed to our mailing list.</h3><p></p></div>",
    };
    SubscribeCustomerToNewsletter(DyNewsletterPullup, true);
    return false;
  });
};

export default DyNewsletterPullUpExperience;
